export class ResponseError extends Error {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(data: any) {
    if (typeof data === 'object' && data !== null) {
      super(JSON.stringify(data))
    } else {
      super(`${data}`)
    }
    Object.setPrototypeOf(this, ResponseError.prototype)
  }
}

export class InternalInconsistencyError extends Error {
  constructor() {
    super('Internal Inconsistency')
    Object.setPrototypeOf(this, InternalInconsistencyError.prototype)
  }
}

export class UnderflowError extends Error {
  constructor(a: number, b: number) {
    super(`Underflow: ${a} < ${b}`)
    Object.setPrototypeOf(this, UnderflowError.prototype)
  }
}
